/**
 * Created by mateimisarca on 2019-06-15
 */

import WebinariiPage from './webinarii-page';

export default WebinariiPage;
